import { motion } from "framer-motion";
import { Effect } from "../types/effects";

const EffectCard = ({
  effect,
  onClick,
}: {
  effect: Effect;
  onClick: Function;
}) => {
  const handleEffectClick = () => {
    if (onClick) {
      onClick(effect);
    }
  };

  return (
    <motion.div
      className="relative flex-shrink-0 w-40 group cursor-pointer"
      onClick={handleEffectClick}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      {/* Glowing background effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 via-cyan-500/20 to-pink-500/20 rounded-2xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {/* Main card */}
      <div className="relative bg-white/10 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/20 shadow-xl group-hover:shadow-purple-500/25 transition-all duration-300">
        {/* Image container */}
        <div className="relative overflow-hidden">
          <img
            src={effect.image}
            alt={effect.title}
            className="w-full h-24 object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        </div>

        {/* Content area */}
        <div className="relative p-3 bg-gradient-to-t from-black/20 to-transparent">
          <h3 className="text-white font-bold text-sm leading-tight mb-1 drop-shadow-lg truncate">
            {effect.title}
          </h3>
          <div className="h-0.5 bg-gradient-to-r from-purple-400 to-cyan-400 rounded-full w-0 group-hover:w-full transition-all duration-300" />

          {/* Glass particles effect */}
          <div className="absolute bottom-1.5 left-1.5 flex space-x-1">
            {[...Array(3)].map((_, i) => (
              <motion.div
                key={i}
                className="w-0.5 h-0.5 bg-white/40 rounded-full"
                animate={{
                  opacity: [0.4, 0.8, 0.4],
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 2,
                  delay: i * 0.3,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              />
            ))}
          </div>
        </div>

        {/* Corner decorations */}
        <div className="absolute top-0 left-0 w-6 h-6 border-l-2 border-t-2 border-white/30 rounded-tl-2xl" />
        <div className="absolute bottom-0 right-0 w-6 h-6 border-r-2 border-b-2 border-white/30 rounded-br-2xl" />
      </div>
    </motion.div>
  );
};

export default EffectCard;
